<template>
  <el-dialog :visible.sync="visible" :title="$t('roomOweFees.title')" width="80%" top="5vh" custom-class="custom-modal"
    @close="handleClose">
    <el-table :data="roomOweFeesInfo.fees" stripe border style="width: 100%; margin-top: 15px">
      <el-table-column prop="payerObjName" :label="$t('roomOweFees.payerObj')" align="center" />
      <el-table-column prop="ownerName" :label="$t('roomOweFees.ownerName')" align="center" />
      <el-table-column prop="ownerTel" :label="$t('roomOweFees.phone')" align="center" />
      <el-table-column prop="endTime" :label="$t('roomOweFees.startTime')" align="center" />
      <el-table-column prop="deadlineTime" :label="$t('roomOweFees.endTime')" align="center" />
      <el-table-column prop="amountOwed" :label="`${$t('roomOweFees.total')} (${$t('roomOweFees.unit')})`"
        align="center" />
      <el-table-column prop="updateTime" :label="$t('roomOweFees.updateTime')" align="center" />
      <!-- 限制门禁操作列 -->
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button v-if="showRestrictButton(scope.row)" size="mini"
            :type="getRestrictButtonType(scope.row)"
            @click="openRestrictDialog(scope.row)">
            {{ getRestrictButtonText(scope.row) }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="pagination.total > 0" background layout="prev, pager, next" :total="pagination.total"
      :page-size="pagination.pageSize" :current-page="pagination.currentPage" @current-change="handlePageChange"
      style="margin-top: 20px; text-align: right" />

    <!-- 限制门禁延期弹窗 -->
    <el-dialog :title="restrictDialogTitle" :visible.sync="restrictDialogVisible" width="420px" append-to-body>
      <el-form label-width="100px">
        <el-form-item label="延期天数">
          <el-input-number v-model="postponeDays" :min="1" :max="365" style="width:200px"></el-input-number>
          <span style="margin-left:10px;color:#999">1-365天</span>
        </el-form-item>
        <div v-if="currentRestrictRoom" style="padding:10px 0 0 100px;color:#666;font-size:13px">
          <p>房屋：{{ currentRestrictRoom.payerObjName }}</p>
          <p v-if="currentDoorStatus && currentDoorStatus.postponeEndTime">
            当前到期：{{ currentDoorStatus.postponeEndTime }}
          </p>
          <p>到期剩余天数：<span style="color:#E6A23C;font-weight:bold">{{ computedRemainingDays }}</span> 天</p>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="restrictDialogVisible = false">取消</el-button>
        <el-button v-if="currentButtonType === 'YELLOW'" type="danger" @click="cancelRestrict">取消延期</el-button>
        <el-button type="primary" @click="confirmRestrict">
          {{ currentButtonType === 'YELLOW' ? '修改延期' : '确认延期' }}
        </el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getRoomOweFees } from '@/api/room/roomOweFeesApi'
import { queryRoomDoorAccessStatus, saveRoomDoorAccessRestrict } from '@/api/room/roomApi'

export default {
  name: 'RoomOweFees',
  data() {
    return {
      visible: false,
      roomOweFeesInfo: {
        fees: [],
        roomId: ''
      },
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      // 限制门禁相关数据
      feeLinkIotOn: false,
      roomDoorStatusMap: {},
      restrictDialogVisible: false,
      postponeDays: 0,
      currentRestrictRoom: null,
      currentDoorStatus: null,
      currentButtonType: ''
    }
  },
  computed: {
    // 计算门禁到期剩余天数
    computedRemainingDays() {
      if (!this.currentRestrictRoom) return 0
      const days = this.postponeDays || 0
      if (days <= 0) return 0
      const now = new Date()
      const endDate = new Date(now)
      endDate.setDate(endDate.getDate() + days)
      const diffMs = endDate - now
      return Math.ceil(diffMs / (1000 * 60 * 60 * 24))
    },
    // 门禁延期弹窗标题
    restrictDialogTitle() {
      if (!this.currentDoorStatus) return '设置门禁延期'
      if (this.currentDoorStatus.buttonType === 'YELLOW') return '修改门禁延期'
      return '设置门禁延期'
    }
  },
  methods: {
    open(roomId) {
      this.roomOweFeesInfo.roomId = roomId
      this.pagination.currentPage = 1
      this.visible = true
      this.loadData()
    },
    handleClose() {
      this.visible = false
    },
    handlePageChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          communityId: this.getCommunityId(),
          payerObjId: this.roomOweFeesInfo.roomId,
          payerObjType: '3333'
        }

        const response = await getRoomOweFees(params)
        this.roomOweFeesInfo.fees = response.data
        this.pagination.total = response.total

        // 加载门禁状态（用于显示限制门禁按钮）
        if (this.roomOweFeesInfo.roomId) {
          this._loadDoorAccessStatus(this.roomOweFeesInfo.roomId)
        }
      } catch (error) {
        console.error('加载房屋欠费信息失败:', error)
        this.$message.error(this.$t('common.loadFailed'))
      }
    },

    // 加载门禁限制状态
    async _loadDoorAccessStatus(roomId) {
      try {
        // 先重置状态
        this.feeLinkIotOn = false
        this.roomDoorStatusMap = {}
        console.log('doorStatus: 加载门禁状态, roomId=', roomId)
        const res = await queryRoomDoorAccessStatus(this.getCommunityId(), roomId)
        console.log('doorStatus: API返回=', res)
        // res = axios响应, res.data = ResultVo {code, msg, data: {feeLinkIotOn, roomStatusMap}}
        const resultVo = res.data || {}
        const statusData = resultVo.data || {}
        this.feeLinkIotOn = statusData.feeLinkIotOn || false
        this.roomDoorStatusMap = statusData.roomStatusMap || {}
        console.log('doorStatus: feeLinkIotOn=', this.feeLinkIotOn, 'roomDoorStatusMap=', this.roomDoorStatusMap)
      } catch (error) {
        console.error('加载门禁状态失败:', error)
      }
    },

    // 是否显示限制门禁按钮
    showRestrictButton(row) {
      if (!this.feeLinkIotOn) return false
      const status = this.roomDoorStatusMap[row.payerObjId]
      return status && status.buttonType !== 'NONE'
    },

    // 获取按钮类型
    getRestrictButtonType(row) {
      const status = this.roomDoorStatusMap[row.payerObjId]
      return status && status.buttonType === 'RED' ? 'danger' : 'warning'
    },

    // 获取按钮文本
    getRestrictButtonText(row) {
      const status = this.roomDoorStatusMap[row.payerObjId]
      if (!status) return ''
      if (status.buttonType === 'RED') {
        return status.hasPostpone ? '重新限制' : '限制门禁'
      }
      return '已延期'
    },

    // 打开限制门禁弹窗
    openRestrictDialog(row) {
      const status = this.roomDoorStatusMap[row.payerObjId]
      if (!status) return
      this.currentRestrictRoom = row
      this.currentDoorStatus = status
      this.currentButtonType = status.buttonType || 'RED'
      this.postponeDays = status.postponeDays ? parseInt(status.postponeDays) : 1
      this.restrictDialogVisible = true
    },

    // 确认延期
    async confirmRestrict() {
      if (!this.postponeDays || this.postponeDays < 1 || this.postponeDays > 365) {
        this.$message.error('延期天数必须在1-365天之间')
        return
      }
      if (!this.currentRestrictRoom) return
      try {
        const action = 'POSTPONE'
        await saveRoomDoorAccessRestrict({
          communityId: this.getCommunityId(),
          roomId: this.currentRestrictRoom.payerObjId,
          postponeDays: this.postponeDays,
          action: action,
          userName: (this.$getUser() || {}).name || '管理员'
        })
        this.$message.success('延期设置成功')
        this.restrictDialogVisible = false
        // 刷新门禁状态
        await this._loadDoorAccessStatus(this.roomOweFeesInfo.roomId)
      } catch (error) {
        console.error('延期设置失败:', error)
        this.$message.error(error.response ? error.response.data.msg : '延期设置失败')
      }
    },

    // 取消延期
    async cancelRestrict() {
      if (!this.currentRestrictRoom) return
      try {
        await saveRoomDoorAccessRestrict({
          communityId: this.getCommunityId(),
          roomId: this.currentRestrictRoom.payerObjId,
          action: 'CANCEL',
          userName: (this.$getUser() || {}).name || '管理员'
        })
        this.$message.success('已取消延期')
        this.restrictDialogVisible = false
        await this._loadDoorAccessStatus(this.roomOweFeesInfo.roomId)
      } catch (error) {
        console.error('取消延期失败:', error)
        this.$message.error(error.response ? error.response.data.msg : '取消延期失败')
      }
    }
  }
}
</script>

<style scoped>
.custom-modal>>>.el-dialog__body {
  padding: 15px 20px;
}
</style>
